import React, { useState } from 'react';
import parse from 'html-react-parser';
import styled, { css } from 'styled-components';
import {
  useForm,
  FormProvider,
} from 'react-hook-form';
import { _ } from '_locales';

import { isRTL } from '_helpers';
import { Switch } from '_components';
import ConfirmToExport from './components';

// style
const parentWidth = document.getElementById('rcroot').getBoundingClientRect().width;

const ExportContainer = styled.div`
  width: 100%;
  height: auto;
  overflow: hidden;
  box-sizing: border-box;
  padding: 10px 25px;
  font-weight: 500 !important;
`;

const CollectionContainer = styled.li`
    width: 100%;
    height: 64px;
    box-sizing: border-box; 
    padding: 15px 0;
    direction: ${() => (isRTL() ? 'rtl' : 'ltr')};
    display: flex;

    border-bottom: ${({ divNum, collNum }) => ((divNum === collNum) ? 'none' : '1px solid #ccc')};

`;

const CollectionTitle = styled.strong`
    font-size: 16px !important;
    font-weight: 400 !important;
    margin-right: 10px !important;
    flex: 1;
`;

const SwitchContainer = styled.div`
    float: ${({ float }) => (float)};
`;

const CalTypeList = styled.div`
    position: relative;
    padding: 1.2em 0px;
    font-weight: normal !important;
    color: #717171;
    text-shadow: 0 1px 1px #fff;
    display: flex;
    flex-wrap: wrap;

    ${(parentWidth < 431) && css`
      display: block;
    `};
`;

const ReportLabel = styled.label`
  display: none;
`;

const CalSelect = styled.select`
    max-width: calc(100% - 160px);
    flex: 1;
    padding: 14px 12px 11px 12px;
    background: #fff;
    border: 1.5px solid #A0A0A0;
    border-radius: 6px;
    margin-right: 10px;

    ${(parentWidth < 431) && css`
      display: block;
      width: 100%;
      max-width: 100%;
      margin-right: 0px;
    `};
`;

const CalOption = styled.option`
    display: block;
    white-space: pre;
    min-height: 1.2em;
    padding: 0px 2px 1px;
    font-weight: 500 !important;
    font-size: 13px !important;
     
    color: #717171;
`;

/**
 * This component is for sync the collections that you selected to your preferred calendar
 *
 * @author Alireza Zebardast
 * @param {object} plugin
 * @param {object} config
 */
const ExportCalendar = ({ plugin, config }) => {
  const { projectId } = plugin;
  const { selectedLang, districtId, collection } = config;

  const [colObject, setColObject] = useState(
    collection
      && Object.keys(collection).length
      ? new Array(Object.keys(collection).length).fill('') : ''
  );
  const [checked, setChecked] = useState(false);
  const [calType, setCalType] = useState('');
  const [colStr, setColStr] = useState('');

  const methods = useForm();

  const handleChange = (id) => {
    const [index, result, schedule] = id.split('@');
    const mergedCollTitle = `${result}-${schedule}`;

    setChecked(!checked);

    const newCheck = [...colObject];

    if (
      newCheck
      && newCheck[index]
      && Object.keys(newCheck[index]).length
      && newCheck[index][index]
    ) {
      newCheck[index] = { [index]: false, collTitle: mergedCollTitle };
    } else {
      newCheck[index] = { [index]: true, collTitle: mergedCollTitle };
    }

    let collTitleString = '';
    for (let i = 0; i < newCheck.length; i += 1) {
      if (
        newCheck[i] !== ''
        && newCheck[i][i]
      ) {
        collTitleString += `${newCheck[i].collTitle}-`;
      }
    }

    setColStr(collTitleString.slice(0, -1));
    setColObject(newCheck);
  };

  return (
    <div>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <FormProvider {...methods}>
        <ExportContainer>
          <ul>
            {
              collection
              && Object.keys(collection)
                .map((result, index) => (
                  <CollectionContainer
                    key={`${collection[result].title}@${result}@${collection[result].schedule}`}
                    divNum={index}
                    collNum={Object.keys(collection).length - 1}
                  >
                    <CollectionTitle id={collection[result].title}>
                      {parse(collection[result].title)}
                    </CollectionTitle>
                    <SwitchContainer
                      float={(
                        selectedLang === 'fa_IR'
                        || selectedLang === 'ar_SA'
                        || selectedLang === 'ur_UR'
                      ) ? 'left' : 'right'}
                    >
                      <form action="#">
                        <Switch
                          variant="multi"
                          aria-label={`${collection[result].title} Switch`}
                          labelBgColor="#dedede"
                          inputBgColor={process.env.REACT_APP_PRIMARY_COLOR}
                          onChange={() => handleChange(`${index}@${result}@${collection[result].schedule}`)}
                          name={collection[result].title}
                          id={`${index}@${result}@${collection[result].schedule}`}
                        />
                      </form>
                    </SwitchContainer>
                  </CollectionContainer>
                ))
            }
          </ul>

          <CalTypeList>
            <ReportLabel htmlFor="calendar-types">{_('cal.calendar_types')}</ReportLabel>
            <CalSelect
              value={calType}
              id="calendar-types"
              aria-label="choose one of the calendar types"
              onChange={({ target }) => setCalType(target.value)}
            >
              <CalOption value="">{_('cal.choose_calendar')}</CalOption>
              <CalOption value="iCal">{_('cal.ical')}</CalOption>
              <CalOption value="OutLook">{_('cal.outLook')}</CalOption>
              <CalOption value="Google_Calendar">{_('cal.google_calendar')}</CalOption>
              <CalOption value="Other">{_('cal.other')}</CalOption>
            </CalSelect>

            <ConfirmToExport
              colStr={colStr}
              calType={calType}
              colObject={colObject}
              projectId={projectId}
              districtId={districtId}
            />
          </CalTypeList>

        </ExportContainer>
      </FormProvider>
    </div>
  );
};

export default ExportCalendar;
